import React from "react";
import { HOME_THEME } from "../../features/home/theme";
import { translations, LanguageCode } from "../../utils/translations";

interface ServicesGridProps {
  lang?: LanguageCode;
}

const ServicesGrid: React.FC<ServicesGridProps> = ({ lang = "en" }) => {
  const content = translations[lang].automatePage;

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>{content.servicesHeading}</h2>
        <p style={styles.subheading}>{content.servicesSubheading}</p>
        <div style={styles.grid}>
          {content.services.map((service, index) => (
            <div key={index} style={styles.card}>
              <span style={styles.accent} />
              <h3 style={styles.cardTitle}>{service.title}</h3>
              <p style={styles.cardText}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "40px 5%",
    background: HOME_THEME.surface,
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center" as const,
    fontSize: "1.9rem",
    fontWeight: 800,
    margin: "0 0 6px 0",
    color: HOME_THEME.heroHeading,
  },
  subheading: {
    textAlign: "center" as const,
    maxWidth: "640px",
    margin: "0 auto 26px",
    color: HOME_THEME.muted,
    lineHeight: 1.5,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
  },
  card: {
    position: "relative" as const,
    padding: "20px",
    borderRadius: "14px",
    background: HOME_THEME.surfaceAlt,
    border: `1px solid ${HOME_THEME.border}`,
    overflow: "hidden" as const,
  },
  accent: {
    display: "block",
    width: "36px",
    height: "4px",
    borderRadius: "999px",
    background: HOME_THEME.primary,
    marginBottom: "14px",
  },
  cardTitle: {
    margin: "0 0 8px 0",
    fontSize: "1.1rem",
    fontWeight: 700,
    color: HOME_THEME.heroHeading,
  },
  cardText: {
    margin: 0,
    fontSize: "0.92rem",
    lineHeight: 1.55,
    color: HOME_THEME.muted,
  },
};

export default ServicesGrid;
